import { downloadFileLink } from '@/apis/announcementApi'
import React, { useEffect, useState } from 'react'

const ImageCache = {}
window.test = ImageCache
const CustomImage = ({ s3Path, src, renderCompo, style, alt }) => {
  const [url, setUrl] = useState(ImageCache[s3Path])

  const handleUrl = async (s3Path) => {
    const { download_link } = await downloadFileLink(s3Path)
    const res = await fetch(download_link)
    const blobUrl = URL.createObjectURL(await res.blob())
    ImageCache[s3Path] = blobUrl
    setUrl(blobUrl)
  }

  useEffect(() => {
    if (s3Path) {
      if (ImageCache[s3Path]) {
        setUrl(ImageCache[s3Path])
      } else {
        handleUrl(s3Path)
      }
    } else {
      setUrl("")
    }
  }, [s3Path])

  if (url) return <img src={url} style={style} alt={alt} />
  if (renderCompo) return renderCompo
  return (
    <img src={src} style={style} alt={alt} />
  )
}

export default CustomImage